import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

/**
 * A friendly dialog that appears when the user is offline and a request fails.
 * Shows a cloud-offline emoji and a helpful message.
 */
const OfflineDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: 1500 }} // System dialog — always visible above any other dialog
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          overflow: "hidden",
        },
      }}
    >
      {/* Graphic at the top */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #607d8b 0%, #455a64 100%)",
          py: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "3.5rem !important",
            lineHeight: 1,
            filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))",
            animation: "signal-pulse 1.5s ease-in-out infinite",
            "@keyframes signal-pulse": {
              "0%, 100%": { opacity: 0.4 },
              "50%": { opacity: 1 },
            },
          }}
        >
          📡
        </Typography>
        <Typography
          sx={{
            fontSize: "4rem !important",
            lineHeight: 1,
            filter: "drop-shadow(4px 4px 8px rgba(0,0,0,0.3))",
          }}
        >
          ☁️
        </Typography>
        <Typography
          sx={{
            fontSize: "3.5rem !important",
            lineHeight: 1,
            filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))",
            animation: "signal-pulse 1.5s ease-in-out infinite",
            "@keyframes signal-pulse": {
              "0%, 100%": { opacity: 0.4 },
              "50%": { opacity: 1 },
            },
          }}
        >
          📶
        </Typography>
      </Box>

      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "1.5rem",
          pt: 3,
          pb: 1,
        }}
      >
        You're offline!
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          It looks like you've lost your internet connection.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Don't worry - you can try again once you're back online.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            borderRadius: 2,
            px: 4,
            background: "linear-gradient(135deg, #607d8b 0%, #455a64 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #455a64 0%, #37474f 100%)",
            },
          }}
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OfflineDialog;
